export default __webpack_public_path__ + "static/client7-1e9eb47a407682dc9ce402d19ab160ef.png";